import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=cfbf4128&scoped=true&"
import script from "./UploadFileForm.vue?vue&type=script&lang=js&"
export * from "./UploadFileForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileForm.vue?vue&type=style&index=0&id=cfbf4128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbf4128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFileInput,VForm,VRow})
